import { userDetailsSlice } from "./UserDetails.redux";

export const { setUserDetails } = userDetailsSlice.actions
